import React from 'react'
import {Amazon} from "../data/productList";
import btn from './learn-more-btn.png'

export const AmazonLearnMoreBtn = ({amazon}: {amazon: Amazon}) => (
    <a href={amazon.textLink} target="_blank" rel="noopener noreferrer"><img src={btn} alt="Learn more button"/></a>
);